//Connection Actions
export const setOutput = (output) => ({
    type: 'SET_OUTPUT',
    output
});
export const setInput = (input) => ({
    type: 'SET_INPUT',
    input
});
export const setSaveStatus = saveStatus => ({
    type: 'SET_SAVE_STATUS',
    saveStatus
});

export const setFileName = fileName => ({
    type: 'SET_FILE_NAME',
    fileName
});

//Action List Actions
export const filterActionList = filterString => ({
    type: 'FILTER_ACTION_LIST',
    filterString
});

export const addAction = (actionID, actionName) => ({
    type: 'ADD_ACTION',
    actionID,
    actionName
});

export const removeAction = actionID => ({
    type: 'REMOVE_ACTION',
    actionID
});

export const copyButtonActions = (actions, preset, buttonID) => ({
    type: 'COPY_BUTTON_ACTIONS',
    actions
});

export const pasteButtonActions = (preset, buttonID, clipboard) => ({
    type: 'PASTE_BUTTON_ACTIONS',
    preset,
    buttonID,
    clipboard
});

export const toggleAction = (actionID, enabled) => ({
    type: 'TOGGLE_ACTION',
    actionID,
    enabled
});

export const addActionGroup = actionGroupID => ({
    type: 'ADD_ACTION_GROUP',
    actionGroupID
});

export const removeActionGroup = actionGroupID => ({
    type: 'REMOVE_ACTION_GROUP',
    actionGroupID
});

//Button Actions
export const addButton = button => ({
    type: 'ADD_BUTTON',
    button
});

export const removeButton = buttonID => ({
    type: 'REMOVE_BUTTON',
    buttonID
});

export const setCurrentButton = buttonID => ({
    type: 'SET_CURRENT_BUTTON',
    buttonID
});


export const addActionToButton = (preset, buttonID, actionName, action) => ({
    type: 'ADD_ACTION_TO_BUTTON',
    preset,
    buttonID,
    actionName,
    action
});

export const removeActionFromButton = (preset, buttonID, actionID) => ({
    type: 'REMOVE_ACTION_FROM_BUTTON',
    preset,
    buttonID,
    actionID
});

export const loadActions = (actions) => ({
    type: 'LOAD_ACTIONS',
    actions
});

export const minimizeAction = (preset, buttonID, actionID) => ({
    type: 'MINIMIZE_ACTION',
    preset,
    buttonID,
    actionID
});

export const maximizeAction = (preset, buttonID, actionID) => ({
    type: 'MAXIMIZE_ACTION',
    preset,
    buttonID,
    actionID
});

export const isDownloading = (downloading) => ({
    type: 'IS_DOWNLOADING',
    downloading
});
export const clearActions = () => ({
    type: 'CLEAR_ACTIONS'
});
export const changeOptionValue = (preset, buttonID, actionID, optionID, dataSlot, optionValue) => ({
    type: 'CHANGE_OPTION_VALUE',
    preset,
    buttonID,
    actionID,
    optionID,
    dataSlot,
    optionValue
});

export const changeGlobalSetting = (optionName, optionValue) => ({
    type: 'CHANGE_GLOBAL_SETTING',
    optionName,
    optionValue
});
export const changeExecuteOn = (preset, buttonID, actionID, executeOn) => ({
    type: 'CHANGE_EXECUTE_ON',
    preset,
    buttonID,
    actionID,
    executeOn
});

export const toggleModal = (modal) => ({
    type: 'TOGGLE_MODAL',
    modal
});
export const beforeUnload = (event) => ({
    type: 'BEFORE_UNLOAD',
    event
});
export const toggleSettings = (screen) => ({
    type: 'TOGGLE_SETTINGS',
    screen
});

export const switchScreen = (screen) => ({
    type: 'SWITCH_SCREEN',
    screen
});
export const loadSettings = (settings) => ({
    type: 'LOAD_SETTINGS',
    settings
});

export const selectPreset = (preset) => ({
    type: 'SELECT_PRESET',
    preset
});
export const setPresetName = (preset, presetName) => ({
    type: 'SET_PRESET_NAME',
    preset,
    presetName
});

export const runJoyride = (shouldRun, reset) => ({
    type: 'RUN_JOYRIDE',
    shouldRun
});

export const changePresetColor = (preset, setting) => ({
    type: 'CHANGE_PRESET_COLOR',
    preset,
    setting
});

export const loadPresetSettings = (settings) => ({
    type: "LOAD_PRESET_SETTINGS",
    settings
});

export const copyPreset = (current, destination) => ({
    type: "COPY_PRESET",
    current,
    destination
});
export const destinationPresetChange = (destination) => ({
    type: "DESTINATION_PRESET_CHANGE",
    destination
});